import * as React from "react";
import { useState, useEffect } from "react";
import logo from "../../assets/spero_logo_new.png";
import "./Login.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import InputBase from "@mui/material/InputBase";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
import user from "../../assets/user.png";
import key from "../../assets/key.png";
import { useAuth } from "../Context/ContextAPI";
import { useCall } from "../Context/CallContext";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { API_URL } from "../Config/api";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import { motion, AnimatePresence } from "framer-motion"; // <-- AnimatePresence import kiya

export default function Loginextentions() {
  const { handleAuth } = useAuth();
  const { connectSocket } = useCall();
  const [login, setLogin] = useState({
    clg_ref_id: "",
    password: "",
    extensions: "",
  });
  const [extensionsList, setExtensionsList] = useState([]);
  const [extensionError, setExtensionError] = useState(false);
  const [userIdError, setUserIdError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  // Alerts States
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showExistErrorAlert, setShowExistErrorAlert] = useState(false);
  const [showExistErrorAlert1, setShowExistErrorAlert1] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [showExtAlert, setShowExtAlert] = useState(false);
  const [showExtRequiredAlert, setShowExtRequiredAlert] = useState(false);
  const [showHdOnlyAlert, setShowHdOnlyAlert] = useState(false);
  const [showSelect1111Alert, setShowSelect1111Alert] = useState(false);
  const [showTimeoutAlert, setShowTimeoutAlert] = useState(false);
  const [showNetworkDownAlert, setShowNetworkDownAlert] = useState(false);
  const [customAlert, setCustomAlert] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [isHdUser, setIsHdUser] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchExtensions = async () => {
      if (!login.clg_ref_id.trim()) {
        setExtensionsList([]);
        setLogin((prev) => ({ ...prev, extensions: "" }));
        return;
      }

      try {
        const response = await fetch(
          `${API_URL}/web/extenstion_get/?clg_ref_id=${login.clg_ref_id}`,
        );
        const data = await response.json();

        let fetchedExtensions = [];
        if (Array.isArray(data)) {
          fetchedExtensions = data;
        } else if (data && data.extensions && Array.isArray(data.extensions)) {
          fetchedExtensions = data.extensions;
        }

        setExtensionsList(fetchedExtensions);

        // NAYA LOGIC: Agar sirf "1111" aaya hai toh auto-select karein
        if (
          fetchedExtensions.length === 1 &&
          String(fetchedExtensions[0]) === "1111"
        ) {
          setLogin((prev) => ({ ...prev, extensions: "1111" }));
          setExtensionError(false);
        } else {
          setLogin((prev) => ({ ...prev, extensions: "" }));
        }
      } catch (error) {
        console.error("Error fetching extensions:", error);
        setExtensionsList([]);
      }
    };

    fetchExtensions();
  }, [login.clg_ref_id]);

  const handleChange = async (e) => {
    e.preventDefault();

    const isIdEmpty = !login.clg_ref_id || login.clg_ref_id.trim() === "";
    const isPassEmpty = !login.password || login.password.trim() === "";

    // Sirf tab error dikhao jab list me HD extensions available hon aur select na kiya ho
    const isExtEmpty =
      shouldShowDropdown &&
      (!login.extensions || String(login.extensions).trim() === "");

    setUserIdError(isIdEmpty);
    setPasswordError(isPassEmpty);
    setExtensionError(isExtEmpty);

    if (isIdEmpty || isPassEmpty || isExtEmpty) {
      return;
    }

    const userId = login.clg_ref_id.trim().toLowerCase();
    const selectedExt = String(login.extensions).trim();

    // Admin Validation (Pre-API Call Check)
    if (userId === "admin" && selectedExt !== "1111") {
      setCustomAlert("For Admin login, please select extension 1111");
      setTimeout(() => setCustomAlert(""), 4000);
      return;
    }

    if (isHdUser && selectedExt === "") {
      setExtensionError(true);
      return;
    }

    setLoading(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {
      const currentUrl = window.location.href;
      let isCloudValue = "True"; // Default

      if (
        currentUrl.includes("192.168.1.109:8000") ||
        currentUrl.includes("localhost")
      ) {
        isCloudValue = "False";
      } else {
        isCloudValue = selectedExt === "1111" ? "False" : "True";
      }

      const response = await fetch(`${API_URL}/web/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          clg_ref_id: login.clg_ref_id,
          password: login.password,
          extension_no: login.extensions || "",
          is_cloud: isCloudValue,
        }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (response.status >= 500) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowSelect1111Alert(true);
          setTimeout(() => setShowSelect1111Alert(false), 5000);
        }
        setLoading(false);
        return;
      }

      if (response.status === 401) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowExistErrorAlert1(true);
          setTimeout(() => setShowExistErrorAlert1(false), 3000);
        }
        setLoading(false);
        return;
      } else if (response.status === 404) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowErrorAlert(true);
          setTimeout(() => setShowErrorAlert(false), 3000);
        }
        setLoading(false);
        return;
      } else {
        const data = await response.json();

        if (data.msg === "Extension login allowed only for HD users") {
          setShowHdOnlyAlert(true);
          setTimeout(() => setShowHdOnlyAlert(false), 4000);
          setLoading(false);
          return;
        }

        if (data.msg === "Extension is required for HD users") {
          setIsHdUser(true);
          setShowExtRequiredAlert(true);
          setExtensionError(true);
          setLoading(false);
          return;
        }

        if (data.msg === "Extension already logged in with another user") {
          setShowExtAlert(true);
          setTimeout(() => setShowExtAlert(false), 4000);
          setLoading(false);
          return;
        }

        if (data.msg === "User Already Logged In. Please check.") {
          setShowExistErrorAlert(true);
          setTimeout(() => setShowExistErrorAlert(false), 3000);
        } else {
          // LOGIN SUCCESS & ROUTING
          setSuccessAlert(true);

          localStorage.setItem("loginTime", Date.now());
          localStorage.setItem("selected_extension", login.extensions);
          localStorage.setItem("token", data.token.access);
          localStorage.setItem("refresh", data.token.refresh);
          localStorage.setItem(
            "user-image",
            data.token.colleague.profile_photo_path,
          );
          localStorage.setItem("user-name", data.token.colleague.first_name);
          localStorage.setItem("user-lname", data.token.colleague.last_name);
          localStorage.setItem("user-email", data.token.colleague.email);
          localStorage.setItem("user-phone", data.token.colleague.phone_no);
          localStorage.setItem("user-loc", data.token.colleague.address);
          localStorage.setItem(
            "user-designation",
            data.token.colleague.designation,
          );
          localStorage.setItem("clg_id", data.token.colleague.id);
          localStorage.setItem("hospitalId", data.token.colleague.clg_hosp_id);
          localStorage.setItem("clgrefId", data.token.colleague.clg_ref_id);
          localStorage.setItem("user_group", data.token.user_group);
          localStorage.setItem(
            "permissions",
            JSON.stringify(data.token.permissions),
          );
          localStorage.setItem("companyID", data.token.colleague.prof_compny);

          if (
            data.token.user_group === "hd" &&
            login.extensions &&
            String(login.extensions) !== "1111"
          ) {
            connectSocket(login.extensions);
          }

          setTimeout(() => {
            const group = data.token.user_group;
            handleAuth();

            if (group === "hd") navigate("/dashboard");
            else if (group === "HR") navigate("/hr/manage profiles");
            else if (group === "M_DASH") navigate("/MM2Dashboard");
            else if (group === "HR Partner")
              navigate("/hr partner/manage professionals");
            else if (group === "ADMIN") navigate("/hhc/dashboard");
            else if (group === "ACCOUNT") navigate("/hhc/account/dashboard");
            else if (group === "REPORTS") navigate("/reports/dashboard");
            else if (group === "HOSPITAL") navigate("/hospital/dashboard");
            else if (group === "ATTENDANCE")
              navigate("/attendance/attendance-view");
            else if (group === "MANAGEMENT")
              navigate("/management/management-dashboard");
            else if (group === "clincal_gov") navigate("/hhc/clinical/closure");
            else if (group === "HHC_Analytics") navigate("/analytics/home");
            else if (group === "physio") navigate("/physio");
            else if (group === "physioMilestone") navigate("/physioMilestone");
            else if (group === "Consultant")
              navigate("/hhc/consultant/referred patient details");

            window.location.reload();
          }, 2000);
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        setShowTimeoutAlert(true);
        setTimeout(() => setShowTimeoutAlert(false), 5000);
      } else {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowNetworkDownAlert(true);
          setTimeout(() => setShowNetworkDownAlert(false), 5000);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const onchange = (e) => {
    const { name, value } = e.target;
    setLogin((prev) => ({ ...prev, [name]: value }));
    if (name === "clg_ref_id") setUserIdError(false);
    if (name === "password") setPasswordError(false);
    if (name === "extensions") setExtensionError(false);
  };

  // --- 🔥 BEAUTIFUL FRAMER ANIMATIONS 🔥 ---
  const containerVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 25, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 200, damping: 15 },
    },
  };

  const dropdownVariants = {
    hidden: { opacity: 0, height: 0, marginTop: 0, overflow: "hidden" },
    visible: {
      opacity: 1,
      height: "auto",
      marginTop: 24, // Matches `mt: 3`
      overflow: "visible",
      transition: { duration: 0.3, ease: "easeInOut" },
    },
    exit: {
      opacity: 0,
      height: 0,
      marginTop: 0,
      overflow: "hidden",
      transition: { duration: 0.2, ease: "easeInOut" },
    },
  };

  // Dropdown sirf tab dikhega jab extensions hon (> 0) AUR wo sirf khali "1111" na ho.
  const shouldShowDropdown =
    extensionsList.length > 1 ||
    (extensionsList.length === 1 && String(extensionsList[0]) !== "1111");

  return (
    <div className="container">
      <motion.div
        className="input_fields"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {!isSmallScreen && (
          <motion.div
            variants={itemVariants}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "110px",
                width: "160px",
                borderRadius: "8px",
                marginBottom: "16px",
              }}
            />
          </motion.div>
        )}

        {customAlert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            {customAlert}
          </Alert>
        )}
        {showTimeoutAlert && (
          <Alert severity="warning" variant="filled" sx={{ mt: 2 }}>
            Request timed out.
          </Alert>
        )}
        {showNetworkDownAlert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            Server connection failed.
          </Alert>
        )}
        {showSelect1111Alert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            Extension unavailable.
          </Alert>
        )}
        {successAlert && (
          <Alert severity="success" variant="filled">
            Login Successful!
          </Alert>
        )}
        {showErrorAlert && (
          <Alert severity="error" variant="filled">
            Invalid ID or Password!
          </Alert>
        )}
        {showExistErrorAlert && (
          <Alert severity="error" variant="filled">
            User already logged in!
          </Alert>
        )}
        {showExtAlert && (
          <Alert severity="warning" variant="filled">
            Extension already in use!
          </Alert>
        )}

        {/* User ID Field */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 1,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              borderRadius: "6px",
              border: userIdError ? "1px solid #d32f2f" : "1px solid #000",
            }}
          >
            <img
              src={user}
              alt=""
              style={{ height: "18px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Enter User ID"
              name="clg_ref_id"
              value={login.clg_ref_id}
              onChange={onchange}
              required
            />
          </Box>
          {userIdError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ ml: 1, mt: 0.5, display: "block" }}
            >
              User ID required*
            </Typography>
          )}
        </motion.div>

        {/* Password Field */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 3,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              borderRadius: "6px",
              border: passwordError ? "1px solid #d32f2f" : "1px solid #000",
            }}
          >
            <img
              src={key}
              alt=""
              style={{ height: "20px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 1.2, flex: 1 }}
              placeholder="Enter Password"
              type={showPassword ? "text" : "password"}
              name="password"
              value={login.password}
              onChange={onchange}
              required
            />
            <Button
              onClick={() => setShowPassword(!showPassword)}
              size="small"
              startIcon={showPassword ? <VisibilityOff /> : <Visibility />}
            />
          </Box>
          {passwordError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ ml: 1, mt: 0.5, display: "block" }}
            >
              Password required*
            </Typography>
          )}
        </motion.div>

        {/* 🔥 EXTENSION DROPDOWN WITH ANIMATE PRESENCE 🔥 */}
        <AnimatePresence>
          {shouldShowDropdown && (
            <motion.div
              variants={dropdownVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <Box
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  height: "2.5rem",
                  borderRadius: "6px",
                  border: extensionError
                    ? "1px solid #d32f2f"
                    : "1px solid #000",
                }}
              >
                <PhoneForwardedIcon
                  sx={{
                    fontSize: "18px",
                    ml: 1,
                    color: extensionError ? "#d32f2f" : "black",
                  }}
                />
                <Select
                  displayEmpty
                  name="extensions"
                  value={login.extensions}
                  onChange={onchange}
                  sx={{
                    ml: 1,
                    flex: 1,
                    height: "100%",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Extension
                  </MenuItem>
                  {Array.isArray(extensionsList) &&
                    extensionsList.map((ext, index) => (
                      <MenuItem key={index} value={ext}>
                        {ext}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
              {extensionError && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ ml: 1, mt: 0.5, display: "block" }}
                >
                  Extension required*
                </Typography>
              )}
            </motion.div>
          )}
        </AnimatePresence>

        {/* Submit Button */}
        <motion.div
          variants={itemVariants}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Button
            variant="contained"
            sx={{
              mt: 6,
              width: "100%",
              maxWidth: "28ch",
              height: "7vh",
              backgroundColor: "#69DAC3",
              color: "black",
            }}
            onClick={handleChange}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>
        </motion.div>

        {/* Footer Links */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {[
                "Privacy & Policy",
                "Refund & Cancellation",
                "Contact Us",
                "About Us",
              ].map((label, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  sx={{ cursor: "pointer", "&:hover": { color: "#0072BC" } }}
                >
                  {label}
                </Typography>
              ))}
            </Box>
          </Box>
        </motion.div>
      </motion.div>
    </div>
  );
}
